import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ClientProvider } from "./context/ClientContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import ExecutiveDashboard from "./pages/ExecutiveDashboard";
import Observatory from "./pages/Observatory";
import WorkflowGraph from "./pages/WorkflowGraph";
import ScenarioEngine from "./pages/ScenarioEngine";
import RegressionOptimizer from "./pages/RegressionOptimizer";
import DefectIntelligence from "./pages/DefectIntelligence";
import Orchestration from "./pages/Orchestration";
import SmeAssistant from "./pages/SmeAssistant";
import IntakeHub from "./pages/IntakeHub";
import { Toaster } from "sonner";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <ClientProvider>
        <AppShell>{children}</AppShell>
      </ClientProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell><ExecutiveDashboard /></Shell>} />
            <Route path="/intake" element={<Shell><IntakeHub /></Shell>} />
            <Route path="/observatory" element={<Shell><Observatory /></Shell>} />
            <Route path="/workflows" element={<Shell><WorkflowGraph /></Shell>} />
            <Route path="/scenarios" element={<Shell><ScenarioEngine /></Shell>} />
            <Route path="/regression" element={<Shell><RegressionOptimizer /></Shell>} />
            <Route path="/defects" element={<Shell><DefectIntelligence /></Shell>} />
            <Route path="/orchestration" element={<Shell><Orchestration /></Shell>} />
            <Route path="/sme" element={<Shell><SmeAssistant /></Shell>} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
